// form messages

// error messages
export const ERROR_PASSWORD =
	'Password must be at least 6 characters long and must contain a number, lower case, upper case and special character.';
export const ERROR_CURRENT_PASSWORD_REQUIRED = 'Current password required.';
export const ERROR_CURRENT_PASSWORD_INVALID =
	'Looks like you entered your current password incorrectly.';
export const ERROR_RESET_PASSWORD_NOT_AUTHORISED = 'Password cannot be reset';
export const ERROR_EMAIL_NOT_FOUND = 'Email not found.';

// success messages
export const SUCCESS_PASSWORD_UPDATED_TITLE = 'Success';
export const SUCCESS_PASSWORD_UPDATED = 'Password updated successfully.';

// info messages
export const INFO_PASSWORD_STRENGTH = ERROR_PASSWORD;

//reset password
export const NEW_PASSWORD_REQUIRED = 'A new password is required.';

//forgot password
export const FORGOT_PASSWORD_EMAIL_ERROR = ERROR_EMAIL_NOT_FOUND;



// WEBPACK FOOTER //
// ./src/utils/forms/const-messages.js